import React, { PureComponent }  from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';

import withBuy from './components/withBuy';
import withSell from './components/withSell';

const Loading = (props) => {
  if (props.error) {
    return <div>Error! <button onClick={props.retry}>Retry</button></div>;
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
}

const AsyncHome = Loadable({
  loader: () => import('./containers/Home/Home'),
  loading: Loading
});
const AsyncMarketItems = Loadable({
  loader: () => import('./containers/MarketItems/MarketItems'),
  loading: Loading
});
const AsyncAuctionItem = Loadable({
  loader: () => import('./containers/AuctionItem/AuctionItem'),
  loading: Loading
});
const AsyncSaleItem = Loadable({
  loader: () => import('./containers/SaleItem/SaleItem'),
  loading: Loading
});
const AsyncMyItems = Loadable({
  loader: () => import('./containers/MyItems/MyItems'),
  loading: Loading
});
const AsyncMyItem = Loadable({
  loader: () => import('./containers/MyItem/MyItem'),
  loading: Loading
});

class Routes extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={AsyncHome}/>
        <Route exact path="/marketplace" component={AsyncMarketItems}/>
        <Route exact path="/auction/:id?" component={withBuy(AsyncAuctionItem)}/>
        <Route exact path="/sale/:id?" component={withBuy(AsyncSaleItem)}/>
        <Route exact path="/lockerroom" component={withSell(AsyncMyItems)}/>
        <Route exact path="/item/:id?" component={withSell(AsyncMyItem)}/>
        <Redirect from={'*'} to={'/'}/>
      </Switch>
    );
  };
};


export default withRouter(Routes);



// WEBPACK FOOTER //
// ./src/routes.js